import { render } from "./B2bTableMenuCmrDraft.vue?vue&type=template&id=0ce78837&scoped=true&lang=pug"
import script from "./B2bTableMenuCmrDraft.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuCmrDraft.vue?vue&type=script&lang=js"

import "./B2bTableMenuCmrDraft.vue?vue&type=style&index=0&id=0ce78837&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce78837"]])

export default __exports__